import React from "react";
import { ICON_FAMILY } from "./profile-constants";

function Icon({ family, name }) {
  const cssFamily = ICON_FAMILY[family || 'solid'] || ICON_FAMILY.solid;
  return <i className={cssFamily + ' ' + name} aria-hidden="true" />;
}

export default Icon;
